import { createRuntimeOperationType, isRuntimeOperationConfig } from './common';
export const listToStringOperationType = createRuntimeOperationType({
    kind: 'LIST_TO_STRING',
    dependencies: () => [],
    run: (value, context, operations) => {
        if (!Array.isArray(value)) {
            throw new Error(`LIST_TO_STRING must be an array. Got ${JSON.stringify(value)}`);
        }
        if (value.some(isRuntimeOperationConfig)) {
            return value;
        }
        const [listContentNode] = value;
        if (!listContentNode) {
            return '';
        }
        if (typeof listContentNode !== 'object' ||
            !('kind' in listContentNode) ||
            listContentNode.kind !== 'LIST') {
            throw new Error(`LIST_TO_STRING expects first value to be a ListContentNode. Got ${JSON.stringify(listContentNode)}`);
        }
        const list = listContentNode;
        if (!list.items || list.items.length === 0) {
            return '';
        }
        const hasUnresolvedOperations = list.items.some((item) => {
            if (typeof item === 'object' &&
                item !== null &&
                'state' in item &&
                typeof item.state === 'object' &&
                item.state !== null) {
                return Object.values(item.state).some(isRuntimeOperationConfig);
            }
            return false;
        });
        if (hasUnresolvedOperations) {
            return value;
        }
        const textValues = list.items
            .map((item) => {
            if (typeof item === 'object' &&
                item !== null &&
                'state' in item &&
                typeof item.state === 'object' &&
                item.state !== null &&
                'asText' in item.state) {
                return item.state.asText;
            }
            return null;
        })
            .filter(text => text !== null && text !== undefined);
        return textValues.join(' | ');
    },
});
//# sourceMappingURL=list-to-string.js.map